<template>
  <default-textual-section v-if="$store.state.displayType === 'textual'" :menu="menu" :section="section"
                           :menu-item-component="menuItemComponent"
                           class="menu--section-thanksgiving_dining">
    <template v-slot:sectionTitleImage>
      <h2>
        <img src="/library/images/menu/header-thanksgiving-2025.png" alt="Thanksgiving" class="menu--section_logo">
      </h2>
    </template>
  </default-textual-section>
  <default-visual-section v-else :menu="menu" :section="section"
                          :menu-item-component="menuItemComponent"
                          class="menu--section-thanksgiving_dining">
    <template v-slot:sectionTitleImage>
      <h2>
        <img src="/library/images/menu/header-thanksgiving-2025.png" alt="Thanksgiving" class="menu--section_logo">
      </h2>
    </template>
  </default-visual-section>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.1.0
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-11-05 (1.0.0) (jhoward)
 *    - Copy from Thanksgiving_defaultSection.vue component to Thanksgiving2025_defaultSection.vue component.
 *    - Update header image in Thanksgiving2025_defaultSection to the 2025 version.
 *    - Update background image in Thanksgiving2025_defaultSection to the 2025 version.
 *    - Customize menu type to "DINING" in Thanksgiving2025_defaultSection.
 *    - Modify styles in Thanksgiving2025_defaultSection to match 2025 branding and layout.
 * @changelog
 *
 * 2026-07-20 (0.1.0) (jhoward)
 *   - Add App\Library\Js\Components\Menu\Section\Thanksgiving2025_defaultSection.vue for Thanksgiving 2025 menu sections.
 */

import { defineComponent, PropType } from "vue";
import { ALLOWED_ITEM_COMPONENTS, Menu, MenuSection } from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection
  },
  name: "Thanksgiving2025_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: "thanksgiving-food-item",
      validate: (value: string) => "" === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    }
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  methods: {
    sectionTitle(): string {
      if (this.section.ms_title.length && "thanksgiving dining" !== this.section.ms_title.toLowerCase().substring(0, 19)) {
        return this.section.ms_title;
      }

      return "DINING";
    },
    sectionSubtitle(): string {
      if (this.section.ms_subtitle.length) {
        return this.section.ms_subtitle;
      }

      return (this.menu?.page?.page_h1 || "");//.toUpperCase();
    }
  }
});
</script>

<style scoped>
.menu--section-thanksgiving_dining {
  font-size: 1.4em;
  color: #231f20;
}

.menu--section-thanksgiving_dining::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/library/images/menu/background-thanksgiving-2025.jpg');
  background-size: cover;
  background-position: top center;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--highlight-thanksgiving) {
  color: #b15731;
  font-weight: bold;
}

.menu--section-thanksgiving_dining:deep(.menu--item_title-thanksgiving) {
  font-size: 1.2em;
}

.menu--section-thanksgiving_dining:deep(h2) {
  padding-left: 0;
}

.menu--section-thanksgiving_dining:deep(h2:not(.menu--section_title)) {
  padding-top: 3em;
}

.menu--section-thanksgiving_dining:deep(h2 img) {
  width: 46%;
  min-width: 300px;
}

.menu--section-thanksgiving_dining:deep(.menu--section_title) {
  color: #4E2319;
  font-family: itc-avant-garde-gothic-pro, sans-serif;
  top: -0.65em;
  margin-top: 0;
  letter-spacing: 0.4em;
  font-weight: 300;
  font-size: 1.78em !important;
  transform: scaleY(0.85);
  padding-left: 0;
  padding-bottom: 0.2em;
}

.menu--section-thanksgiving_dining:deep(.menu--section_subtitle) {
  text-align: center;
  font-family: trajan-pro-3, serif;
  color: #b05630;
  font-size: 2.5em;
  width: 80%;
  margin: 0 auto;
  line-height: 1em;
  letter-spacing: initial;
}

@media (max-width: 780px)  {
  .menu--section-thanksgiving_dining:deep(.menu--section_subtitle) {
    font-size: 1.8em;
    width: 100%;
  }
}

.menu--section-thanksgiving_dining:deep(.menu--item_description h4) {
  color: #000;
  font-weight: bold;
  margin-bottom: -0.4em;
}

.menu--section-thanksgiving_dining:deep(.menu--item_description p) {
  margin: 0;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy) {
  position: relative;
  text-align: center;
  padding-top: 1.25em;
  padding-bottom: 1.25em;
  width: 65%;
  margin: 1.25em auto;
 /* border-top: 0.2em solid #6b422e;
  border-bottom: 0.2em solid #6b422e;*/
}

@media (max-width: 780px)  {
  .menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top),
  .menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy) {
    width: 90%;
  }
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top::before),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy::before),
.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top::after),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy::after) {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 65%;
  height: 0.2em;
  transform: translateX(-50%);
  background-color: #6b422e;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top::after),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy::after) {
  top: auto;
  bottom: 0;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top p),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy p) {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 1.4em;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section.visual_menu--page_section-top p:first-child),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-top.page-link-group-copy p:first-child) {
  font-weight: bold;
  font-size: 1.5em;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section-bottom .visual_menu--page_section-bottom),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-bottom.page-link-group-copy) {
  padding-top: 3em;
  margin: 3em;
  position: relative;
  text-align: center;
}

.menu--section-thanksgiving_dining:deep(.visual_menu--page_section-bottom .visual_menu--page_section-bottom::before),
.menu--section-thanksgiving_dining:deep(.menu--page_content.menu--page_content-bottom.page-link-group-copy::before) {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 46%;
  height: 0.2em;
  transform: translateX(-50%);
  background-color: #6b422e;
}

.menu--section-thanksgiving_dining:deep(.menu--highlight) {
  color: #b15731;
  font-weight: bold;
}

.menu--section-thanksgiving_dining.textual_menu--section.body-container:deep(.viewport) {
  width: 60%;
}

@media (max-width: 780px) {
  .menu--section-thanksgiving_dining.textual_menu--section.body-container:deep(.viewport) {
    width: 90%;
  }
}

.menu--section-thanksgiving_dining:deep(.menu_version--container) {
  background-color: #f7e9d0;
}
</style>